import { axios, Response } from '..'

export const deleteTaskById = (taskId: string): Response<null> => {
  return axios.delete(`/v1/tasks/${taskId}`)
}
